module.exports = __webpack_public_path__ + "mainassets/img/nyertes.584d582c.png";